//const isProduction = process.env.NODE_ENV === 'production';
const isProduction = false;
export const log = (...args) => {
  if (!isProduction) console.log(...args);
};

export const warn = (...args) => {
  if (!isProduction) console.warn(...args);
};

export const error = (...args) => {
  if (!isProduction) console.error(...args);
};

export const info = (...args) => {
  if (!isProduction) console.info(...args);
};